<!--小区分4列选择，必须到小区级-->
<template>
    <el-row >
        <el-col :span="span">
            <el-select v-model="provinceCode" placeholder="请选择" @change="getCitys($event,'0')">
                <el-option
                        v-for="item in provinces"
                        :key="item.provinceCode"
                        :label="item.provinceName"
                        :value="item.provinceCode">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="span">
            <el-select v-model="cityCode" placeholder="请选择" @change="getAreas($event,'0')">
                <el-option
                        v-for="item in citys"
                        :key="item.cityCode"
                        :label="item.cityName"
                        :value="item.cityCode">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="span">
            <el-select v-model="areaCode" placeholder="请选择" @change="getCommunitys($event,'0')">
                <el-option
                        v-for="item in areas"
                        :key="item.areaCode"
                        :label="item.areaName"
                        :value="item.areaCode">
                </el-option>
            </el-select>
        </el-col>
        <el-col :span="span">
            <el-select v-model="communityCode1" placeholder="请选择" @change="setCommunity">
                <el-option
                        v-for="item in communitys"
                        :key="item.communityCode"
                        :label="item.communityName"
                        :value="item.communityCode">
                </el-option>
            </el-select>
        </el-col>
    </el-row>
</template>

<script>
    import {getArea, getCity, getCommunity, getProvince} from '@/api/region'

    export default {
        name: '',
        props: {
            span: {
                type: Number,
                default: 6
            },
            communityCode:{
                type: Number,
                default: null
            }
        },
        data(){
            return {
                provinces:[],
                citys:[],
                areas:[],
                communitys:[],
                provinceName:null,
                cityName:null,
                areaName:null,
                communityName:null,
                areaCode:null,
                cityCode:null,
                provinceCode:null,
                communityCode1:null
            }
        },
        methods: {
            getProvinces(){
                console.log('执行getProvinces')
                getProvince().then(response => {
                    if(response.code!=200) return this.$message.error('获取省列表失败！')
                    this.provinces=response.data
                    if(!this.provinceCode){
                        this.provinceCode=this.provinces[0].provinceCode
                    }
                    this.getCitys(this.provinceCode,'')
                })
            },
            getCitys(val,type){
                console.log('getCitys',val,type)
                if(this.provinces.length>0){
                    for (let i = 0; i < this.provinces.length; i++) {
                        if(this.provinces[i].provinceCode===val){
                            this.provinceName=this.provinces[i].provinceName
                        }
                    }
                }
                getCity(this.provinceCode).then(response => {
                    if(response.code!=200) return this.$message.error('获取市列表失败！')
                    this.citys=response.data
                    if(type==='0'||!this.cityCode){
                        this.cityCode=this.citys[0].cityCode
                        this.cityName=this.citys[0].cityName
                    }
                    this.getAreas(this.cityCode,type)
                })
            },
            getAreas(val,type){
                console.log('getAreas',val,type)
                if(this.citys.length>0){
                    for (let i = 0; i < this.citys.length; i++) {
                        if(this.citys[i].cityCode===val){
                            this.cityName=this.citys[i].cityName
                        }
                    }
                }
                getArea(this.cityCode).then(response => {
                    if(response.code!=200) return this.$message.error('获取区列表失败！')
                    this.areas=response.data
                    if(type==='0'||!this.areaCode){
                        this.areaCode=this.areas[0].areaCode
                        this.areaName=this.areas[0].areaName
                    }
                    this.getCommunitys(this.areaCode,type)
                })
            },
            getCommunitys(val,type){
                if(this.areas.length>0){
                    for (let i = 0; i < this.areas.length; i++) {
                        if(this.areas[i].areaCode===val){
                            this.areaName=this.areas[i].areaName
                        }
                    }
                }
                getCommunity({areaCode: this.areaCode, cityCode: this.cityCode, provinceCode: this.provinceCode} ).then(response=>{
                    if(response.code!=200) return this.$message.error('获取小区列表失败！')
                    this.communitys=response.data
                    if(type===''&&!this.communityCode1){
                        if(this.communitys.length>0){
                            this.communityName=this.communitys[0].communityName
                            this.$emit('checkChange', this.communitys[0].communityCode,this.communityName,this.areaName,this.cityName,this.provinceName)
                            this.communityCode1=this.communitys[0].communityCode
                        }
                    }else if(type==='0'||!this.communityCode1){
                        if(this.communitys.length>0){
                            this.communityName=this.communitys[0].communityName
                            this.$emit('checkChange', this.communitys[0].communityCode,this.communityName,this.areaName,this.cityName,this.provinceName)
                            this.communityCode1=this.communitys[0].communityCode
                        }else{
                            //this.$emit('checkChange', null,null,null,null,null)
                            this.communityCode1=null
                            this.$message.error('缺少小区信息！')
                        }
                    }
                })
            },
            setCommunity(val){
                console.log('小区',this.communityCode1)
                this.communityCode1=val
                if(this.communitys.length>0){
                    for (let i = 0; i < this.communitys.length; i++) {
                        if(this.communitys[i].communityCode===val){
                            this.communityName=this.communitys[i].communityName
                            this.$emit('checkChange', val,this.communityName,this.areaName,this.cityName,this.provinceName)
                            break
                        }
                    }
                }
            }
        },
        created(){
            if(this.communityCode){
                if(this.communityCode.toString().length>6){
                    this.communityCode1=this.communityCode
                }else{
                    this.communityCode1=null
                }
                this.areaCode=Number(this.communityCode.toString().substring(0,6))
                this.cityCode=Number(this.communityCode.toString().substring(0,4))
                this.provinceCode=Number(this.communityCode.toString().substring(0,2))
            }
            this.getProvinces()
        },
        /*watch:{
            communityCode:{
                handler: function() {
                    this.areaCode=Number(this.communityCode.toString().substring(0,6))
                    this.cityCode=Number(this.communityCode.toString().substring(0,4))
                    this.provinceCode=Number(this.communityCode.toString().substring(0,2))
                },
                //deep: true
            }
        }*/
    }
</script>

<style scoped>

</style>
